<template>
  <header class="header">
    <nav>
        <h1><img src="../../assets/images/logo.svg"></h1>
        <ul>
            <li><router-link to="/" v-bind:class="{current: isHome}">ブランドガイドライン</router-link></li>
            <li><router-link to="/downloads/logos" v-bind:class="{current: isAbout}">ダウンロード</router-link></li>
        </ul>
    </nav>
    <Button url="https://docs.google.com/forms/d/e/1FAIpQLScQKIAPgi2N84JcC0lONyXd8DlpoiDSsYuFeYMLX8vUinLsIw/viewform" target="_blank">使用許諾をリクエスト</Button>
  </header>
</template>

<script>
import Button from '../Atoms/Button'

export default {
  name: 'Header',
  data () {
    return {
      msg: 'Header'
    }
  },
  props: ['isHome', 'isAbout'],
  components: {
    Button
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
header {
    width: 100%;
    height: 7.2rem;
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 0 14.4rem;
    box-sizing: border-box;
    position: fixed;
    top: 0;
    background: rgba(255,255,255, 0.2);
    backdrop-filter: blur(16px);
    z-index: 99;
}

@media screen and (max-width: 1440px) {
  header {
    padding: 0 9.6rem;
  }
}

@media screen and (max-width: 1024px) {
  header {
    padding: 0 7.2rem;
  }
}
nav {
    display: flex;
    align-items: center;
    justify-content: flex-start;
}

h1{
  font-weight: normal;
  margin-right: 7.2rem;
}

h1 img {
  height: 7.2rem;
  width: auto;
}

ul {
  list-style-type: none;
  padding: 0;
  display: flex;
}
li {
    height: 7.2rem;
    padding: 0;
    position: relative;
    margin-right: 3.2rem;
}
li a {
  font-size: var(--small-font-size);
  color: #333;
  text-decoration: none;
  font-weight: bold;
  display: block;
  line-height: 5.14285714286;
  transition: .5s;
}

li a:hover{
    color: var(--novasell-green);
    transition: .1s ease-in-out;
}

li a:after {
  content: "";
    display: block;
    width: 0%;
    height: .4rem;
    border-radius: .4rem;
    background: var(--novasell-green);
    position: absolute;
    bottom: 0;
    transition: 0.3s ease-in-out;
}

li a.current:after, li a:hover:after{
    width: 100%;
    transition: 0.1s;
}

</style>



// WEBPACK FOOTER //
// src/components/Molecules/Header.vue